"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[446,547],{

/***/ 547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var FormInput = function FormInput(_ref) {
  var name = _ref.name,
      id = _ref.id,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      placeholder = _ref.placeholder,
      required = _ref.required,
      className = _ref.className,
      onChange = _ref.onChange,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      register = _ref.register,
      _ref$darkSupport = _ref.darkSupport,
      darkSupport = _ref$darkSupport === void 0 ? true : _ref$darkSupport;
  var options = {
    name: name,
    onChange: onChange,
    required: required
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("span", {
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("label", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        'text-white-3': darkSupport,
        'text-gray-900': !darkSupport
      }, 'block text-p3 lg:text-p2 font-medium mb-1.5 overflow-hidden text-ellipsis whitespace-nowrap'),
      htmlFor: id,
      children: label
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "relative w-full",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("input", _objectSpread(_objectSpread({
        type: type,
        id: id,
        placeholder: placeholder,
        required: required
      }, register !== null && register !== void 0 ? register : options), {}, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, {
          'border-white': darkSupport
        }, {
          'border-black': !darkSupport
        }, 'rounded-md h-[2.875rem] block w-full shadow-sm p-3 border', 'bg-white-2 text-p3', {
          'text-gray-1 placeholder-gray-7 focus:ring-gray-800 focus:border-gray-500': !hasError,
          'border-red-300 text-red-500 placeholder-red-500': hasError,
          'focus:ring-red-500 focus:border-red-500 focus:outline-none': hasError
        })
      })), hasError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_3__/* .ExclamationCircleIcon */ .$Ow, {
          className: "h-5 w-5 text-red-500",
          "aria-hidden": "true"
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FormInput);

/***/ }),

/***/ 3446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.esm.js
var popover_esm = __webpack_require__(8305);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 3 modules
var transition_esm = __webpack_require__(9196);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(7804);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var solid_esm = __webpack_require__(4653);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/next-slicezone/dist/index.module.js
var index_module = __webpack_require__(1620);
// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(3416);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./hooks/useLinkResolver.ts
var useLinkResolver = __webpack_require__(3949);
// EXTERNAL MODULE: ./utils/common.ts
var common = __webpack_require__(8058);
// EXTERNAL MODULE: ./components/LinkWithQuery.tsx
var LinkWithQuery = __webpack_require__(1590);
// EXTERNAL MODULE: ./utils/colors.ts
var colors = __webpack_require__(5963);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/HeaderBU.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var groupByBusinessUnit = function groupByBusinessUnit(products, bu) {
  var productsAssociated = products.filter(function (p) {
    return p.businessUnit === bu.businessUnitKey;
  });
  return productsAssociated;
};
var getPrismicLink = function getPrismicLink(link, data) {
  if ((link === null || link === void 0 ? void 0 : link.type) === 'clusterpage') {
    var _data$clusters;

    var verticalData = (_data$clusters = data.clusters) === null || _data$clusters === void 0 ? void 0 : _data$clusters.find(function (cluster) {
      return cluster.id === link.id;
    });

    var newLink = _objectSpread(_objectSpread({}, link), {}, {
      data: verticalData === null || verticalData === void 0 ? void 0 : verticalData.data
    });

    return prismic_reactjs.Link.url(newLink, common/* prismicLinkResolver */.LT);
  }

  return prismic_reactjs.Link.url(link, common/* prismicLinkResolver */.LT);
};

var getBusinessUnitsWithProducts = function getBusinessUnitsWithProducts(products, businessUnits) {
  var buWithProducts = (0,toConsumableArray/* default */.Z)(new Set(products.flatMap(function (p) {
    return p.businessUnit;
  })));

  return businessUnits.filter(function (_ref) {
    var businessUnitKey = _ref.businessUnitKey;
    return buWithProducts.includes(businessUnitKey);
  });
};

var getBusinessUnitsWithoutProducts = function getBusinessUnitsWithoutProducts(products, businessUnits) {
  var buWithProducts = (0,toConsumableArray/* default */.Z)(new Set(products.flatMap(function (p) {
    return p.businessUnit;
  })));

  return businessUnits.filter(function (_ref2) {
    var businessUnitKey = _ref2.businessUnitKey;
    return !buWithProducts.includes(businessUnitKey);
  });
};

var HeaderBU = function HeaderBU(_ref3) {
  var data = _ref3.data;
  var businessUnitsMenu = getBusinessUnitsWithProducts(data.productsByBu, data.businessUnit);
  var businessUnitsLinks = getBusinessUnitsWithoutProducts(data.productsByBu, data.businessUnit);
  var getColumnClass = (0,react.useCallback)(function () {
    var cols = businessUnitsMenu.length;
    if (businessUnitsLinks.length) cols += 1;

    switch (cols) {
      case 1:
        return 'md:grid-cols-1';

      case 2:
        return 'md:grid-cols-2';

      case 3:
        return 'md:grid-cols-3';

      case 4:
        return 'md:grid-cols-4';

      case 5:
        return 'md:grid-cols-5';

      case 6:
        return 'md:grid-cols-6';

      default:
        return 'md:grid-cols-1';
    }
  }, [businessUnitsLinks, businessUnitsMenu]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-6 py-10 lg:px-8",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      className: classnames_default()('grid gap-y-6 gap-x-6 md:gap-x-8 md:gap-y-0', getColumnClass()),
      children: [!!businessUnitsLinks.length && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flow-root",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "-my-2",
            children: businessUnitsLinks.map(function (item) {
              var _item$businessUnitLin, _item$businessUnitLin2;

              var verticalColor = item.color ? (0,colors/* getColor */.Lq)(item.color, 600) : null;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                  href: getPrismicLink(item.businessUnitLink, data),
                  target: (_item$businessUnitLin = (_item$businessUnitLin2 = item.businessUnitLink) === null || _item$businessUnitLin2 === void 0 ? void 0 : _item$businessUnitLin2.target) !== null && _item$businessUnitLin !== void 0 ? _item$businessUnitLin : '_self',
                  className: "flex gap-x-4 py-2 text-sm font-semibold leading-6",
                  children: [verticalColor && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: classnames_default()('block w-1 rounded-full flex-none', verticalColor.bg)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: [item.name, /*#__PURE__*/(0,jsx_runtime.jsx)("small", {
                      className: "block text-xxs leading-3 text-gray-600",
                      children: item.description
                    })]
                  })]
                }, (0,index_browser/* nanoid */.x0)())
              }, item.name);
            })
          })
        })
      }), businessUnitsMenu.map(function (bu) {
        var productsAssociated = groupByBusinessUnit(data.productsByBu, bu);
        var verticalColor = bu.color ? (0,colors/* getColor */.Lq)(bu.color, 600) : null;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flow-root",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
              className: "flex gap-x-4 text-sm font-medium leading-6 text-gray-500",
              children: [verticalColor && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: classnames_default()('block w-1 rounded-full flex-none', verticalColor.bg)
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: [bu.name, /*#__PURE__*/(0,jsx_runtime.jsx)("small", {
                  className: "block text-xxs leading-3 text-gray-600",
                  children: bu.description
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-6 flow-root",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-my-2 flex flex-col",
                children: productsAssociated.map(function (item) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
                    href: getPrismicLink(item.link, data),
                    className: "gap-x-4 py-2 text-sm font-semibold leading-6",
                    children: item.title
                  }, (0,index_browser/* nanoid */.x0)());
                })
              })
            })]
          })
        }, bu.name);
      })]
    })
  });
};

/* harmony default export */ var components_HeaderBU = (HeaderBU);
// EXTERNAL MODULE: ./utils/prismic.ts
var prismic = __webpack_require__(1369);
;// CONCATENATED MODULE: ./components/HeaderProductsMenu.tsx



function HeaderProductsMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function HeaderProductsMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HeaderProductsMenu_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HeaderProductsMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var HeaderProductsMenu_getPrismicLink = function getPrismicLink(link, clusters) {
  if ((link === null || link === void 0 ? void 0 : link.type) === 'clusterpage') {
    var verticalData = clusters === null || clusters === void 0 ? void 0 : clusters.find(function (cluster) {
      return cluster.id === link.id;
    });

    var newLink = HeaderProductsMenu_objectSpread(HeaderProductsMenu_objectSpread({}, link), {}, {
      data: verticalData === null || verticalData === void 0 ? void 0 : verticalData.data
    });

    return prismic_reactjs.Link.url(newLink, common/* prismicLinkResolver */.LT);
  }

  return prismic_reactjs.Link.url(link, common/* prismicLinkResolver */.LT);
};

var HeaderProductsMenu = function HeaderProductsMenu(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      clusters = _ref.clusters;

  var headerKeys = (0,toConsumableArray/* default */.Z)(new Set(data.flatMap(function (cluster) {
    return !cluster.isHeader && cluster.key;
  }))).filter(function (k) {
    return k;
  });

  var headers = data.filter(function (cluster) {
    return cluster.isHeader && headerKeys.includes(cluster.key);
  });
  var mainLinks = data.filter(function (cluster) {
    return !headers.map(function (h) {
      return h.key;
    }).includes(cluster.key);
  });
  var productsLinks = data.filter(function (cluster) {
    return !cluster.isHeader;
  });
  var getColumnClass = (0,react.useCallback)(function () {
    var cols = headers.length;
    if (headers.length) cols += 1;

    switch (cols) {
      case 1:
        return 'md:grid-cols-1';

      case 2:
        return 'md:grid-cols-2';

      case 3:
        return 'md:grid-cols-3';

      case 4:
        return 'md:grid-cols-4';

      case 5:
        return 'md:grid-cols-5';

      case 6:
        return 'md:grid-cols-6';

      default:
        return 'md:grid-cols-1';
    }
  }, [headers]);
  if (!(data !== null && data !== void 0 && data.length)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "mx-auto grid lg:pl-[3.875rem] max-w-8x5l grid-cols-1 gap-x-8 gap-y-10 px-6 py-10 lg:px-8",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      className: classnames_default()('grid gap-y-6 gap-x-6 md:gap-x-8 md:gap-y-0', getColumnClass()),
      children: [!!mainLinks.length && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flow-root",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "-my-2",
            children: mainLinks.map(function (item) {
              var _item$link$target, _item$link;

              var verticalColor = item.color ? (0,colors/* getColor */.Lq)(item.color, 600) : null;
              var pillColor = (0,colors/* getColor */.Lq)(item.pillColor, 500);
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                  href: HeaderProductsMenu_getPrismicLink(item.link, clusters),
                  target: (_item$link$target = (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.target) !== null && _item$link$target !== void 0 ? _item$link$target : '_self',
                  className: "flex gap-x-4 py-2 text-sm font-semibold leading-6 relative",
                  children: [verticalColor && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: classnames_default()('block w-1 rounded-full flex-none', verticalColor.bg)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: [item.title, item.pillLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()('inline-block rounded-[4px] text-xxs leading-[10px] py-0.5 px-1 opacity-80 ml-1 absolute', pillColor.bg, pillColor.textContrast),
                      children: item.pillLabel
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("small", {
                      className: "block text-xxs leading-3 text-gray-600",
                      children: item.description
                    })]
                  })]
                }, item.title)
              }, item.title);
            })
          })
        })
      }), headers.map(function (header) {
        var products = productsLinks.filter(function (p) {
          return p.key === header.key;
        });
        var verticalColor = header.color ? (0,colors/* getColor */.Lq)(header.color, 600) : null;
        var pillColor = (0,colors/* getColor */.Lq)(header.pillColor, 500);
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flow-root",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
              className: "flex gap-x-4 text-sm font-medium leading-6 text-gray-500",
              children: [verticalColor && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: classnames_default()('block w-1 rounded-full flex-none', verticalColor.bg)
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                  href: HeaderProductsMenu_getPrismicLink(header.link, clusters),
                  className: classnames_default()('gap-x-4 py-2 text-sm font-semibold leading-6 relative', {
                    'pointer-events-none': !(0,prismic/* hasLink */.A)(header.link)
                  }),
                  children: [header.title, header.pillLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: classnames_default()('inline-block rounded-[4px] text-xxs leading-[10px] py-0.5 px-1 opacity-80 ml-1 absolute', pillColor.bg, pillColor.textContrast),
                    children: header.pillLabel
                  })]
                }, header.title), /*#__PURE__*/(0,jsx_runtime.jsx)("small", {
                  className: "block text-xxs leading-3 text-gray-600",
                  children: header.description
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-6 flow-root",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-my-2 flex flex-col",
                children: products.map(function (item) {
                  var productPillColor = (0,colors/* getColor */.Lq)(item.pillColor, 500);
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                    href: HeaderProductsMenu_getPrismicLink(item.link, clusters),
                    className: "gap-x-4 py-2 text-sm font-semibold leading-6 relative",
                    children: [item.title, item.pillLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()('inline-block rounded-[4px] text-xxs leading-[10px]', 'py-0.5 px-1 opacity-80 ml-1 absolute', productPillColor.bg, productPillColor.textContrast),
                      children: item.pillLabel
                    })]
                  }, item.title);
                })
              })
            })]
          })
        }, header.title);
      })]
    })
  });
};

/* harmony default export */ var components_HeaderProductsMenu = (HeaderProductsMenu);
// EXTERNAL MODULE: ./components/CurrencyMenu/CurrencyMenu.tsx + 16 modules
var CurrencyMenu = __webpack_require__(9445);
;// CONCATENATED MODULE: ./components/Header.tsx




















var MenuContext;

(function (MenuContext) {
  MenuContext["products"] = "products";
  MenuContext["content"] = "content";
  MenuContext["bu"] = "bu";
})(MenuContext || (MenuContext = {}));

var Header = function Header(_ref) {
  var _data$logo, _data$products, _data$businessUnit, _data$productsMenu, _data$links, _data$content, _data$logo2, _data$businessUnit2, _data$productsMenu2, _data$products2, _data$links2, _data$content2, _data$content3;

  var data = _ref.data,
      resolver = _ref.resolver;
  var timeout;
  var timeoutDuration = 0;
  var slices = data.slices || data.body;
  var buttonRef = (0,react.useRef)(null);
  var buttonContentRef = (0,react.useRef)(null);
  var buttonBusinessUnitRef = (0,react.useRef)(null);
  var buttonClustersRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      openState = _useState[0],
      setOpenState = _useState[1];

  var _useState2 = (0,react.useState)(false),
      mobileOpen = _useState2[0],
      setMobileOpen = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      mobileTouch = _useState3[0],
      setMobileTouch = _useState3[1];

  var homePageLink = (0,useLinkResolver/* useLinkResolver */.u)('/');

  var toggleMenu = function toggleMenu(context) {
    setOpenState(function (openStatePrev) {
      return !openStatePrev;
    });
    var contextRef;

    if (context) {
      var _contextRef, _contextRef$current, _contextRef2, _contextRef2$current;

      switch (context) {
        case MenuContext.products:
          contextRef = buttonRef;
          break;

        case MenuContext.content:
          contextRef = buttonContentRef;
          break;

        case MenuContext.bu:
          contextRef = buttonBusinessUnitRef;
          break;

        default:
          contextRef = null;
          break;
      }

      (_contextRef = contextRef) === null || _contextRef === void 0 ? void 0 : (_contextRef$current = _contextRef.current) === null || _contextRef$current === void 0 ? void 0 : _contextRef$current.click();
      (_contextRef2 = contextRef) === null || _contextRef2 === void 0 ? void 0 : (_contextRef2$current = _contextRef2.current) === null || _contextRef2$current === void 0 ? void 0 : _contextRef2$current.blur();
    }
  };

  var onHover = function onHover(open, context, action) {
    if (mobileTouch) return;

    if (!open && !openState && action === 'onMouseEnter' || open && openState && action === 'onMouseLeave') {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        return toggleMenu(context);
      }, timeoutDuration);
    }
  };

  var onMobileTouch = function onMobileTouch(action) {
    if (action === 'onTouchStart') {
      setMobileTouch(true);
    } else if (action === 'onMouseUp') {
      setMobileTouch(false);
    }
  };

  var handleClick = function handleClick(open) {
    setOpenState(!open);
    clearTimeout(timeout);
  };

  var handleMobileClick = function handleMobileClick() {
    setMobileOpen(!mobileOpen);
  };

  var handleClickOutside = function handleClickOutside(event) {
    var _buttonRef$current, _buttonContentRef$cur, _buttonBusinessUnitRe, _buttonClustersRef$cu;

    var isProductsButton = (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.contains(event.target);
    var isContentButton = (_buttonContentRef$cur = buttonContentRef.current) === null || _buttonContentRef$cur === void 0 ? void 0 : _buttonContentRef$cur.contains(event.target);
    var isBusinessUnitsButton = (_buttonBusinessUnitRe = buttonBusinessUnitRef.current) === null || _buttonBusinessUnitRe === void 0 ? void 0 : _buttonBusinessUnitRe.contains(event.target);
    var isClustersButton = (_buttonClustersRef$cu = buttonClustersRef.current) === null || _buttonClustersRef$cu === void 0 ? void 0 : _buttonClustersRef$cu.contains(event.target);

    if (!isProductsButton && !isContentButton && !isBusinessUnitsButton && !isClustersButton) {
      event.stopPropagation();
    }
  };

  (0,react.useEffect)(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(popover_esm/* Popover */.J, {
    className: "border-b border-b-gray-2 bg-black-1 z-[60] -mb-px sticky top-0",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('dh-content py-4 lg:py-6 flex justify-between items-center', 'h-10 lg:h-15 lg:ml-0 lg:pl-[3.875rem] lg:justify-start lg:max-w-full', 'w-full md:justify-start md:space-x-12 3xl:max-w-8x5l 3xl:m-auto'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          className: "flex",
          href: homePageLink,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "sr-only",
            children: "Digital House"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "max-h-4 w-42",
            children: Boolean((_data$logo = data.logo) === null || _data$logo === void 0 ? void 0 : _data$logo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: data.logo.url,
              alt: data.logo.alt,
              width: data.logo.dimensions.width,
              height: data.logo.dimensions.height,
              layout: "responsive",
              objectFit: "contain",
              priority: true
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "-mr-2 -my-2 md:hidden",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
          className: classnames_default()('bg-white dark:bg-black rounded-md p-2 inline-flex items-center justify-center', 'text-gray-400 dark:text-white hover:text-gray-500 hover:bg-gray-100 focus:outline-none', 'focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "sr-only",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "6JcmZk",
              defaultMessage: [{
                "type": 0,
                "value": "Abrir menú"
              }]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* MenuIcon */.Oqj, {
            className: "h-6 w-6",
            "aria-hidden": "true",
            onClick: handleMobileClick
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "hidden md:flex-1 md:flex md:items-center md:justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(popover_esm/* Popover.Group */.J.Group, {
          as: "nav",
          className: "flex space-x-12 w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "grow flex space-x-12",
            children: [((_data$products = data.products) === null || _data$products === void 0 ? void 0 : _data$products.length) > 0 && data.productsLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover */.J, {
              className: "relative",
              children: function children(_ref2) {
                var _data$seeMoreProducts, _data$seeMoreProducts2;

                var open = _ref2.open;
                return (
                  /*#__PURE__*/
                  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                  (0,jsx_runtime.jsxs)("div", {
                    className: "pb-3 -mb-3",
                    onMouseEnter: function onMouseEnter() {
                      return onHover(open, MenuContext.products, 'onMouseEnter');
                    },
                    onMouseLeave: function onMouseLeave() {
                      return onHover(open, MenuContext.products, 'onMouseLeave');
                    },
                    onTouchStart: function onTouchStart() {
                      return onMobileTouch('onTouchStart');
                    },
                    onMouseUp: function onMouseUp() {
                      return onMobileTouch('onMouseUp');
                    },
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Button */.J.Button, {
                      ref: buttonRef,
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(open ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-300', 'group lg:bg-white lg:dark:bg-black rounded-md inline-flex items-center text-base', 'font-medium hover:text-gray-900 dark:hover:text-white focus:outline-none', 'focus-visible:ring-2 focus-visible:ring-offset-4 focus-visible:ring-primary-500', 'cursor-default'),
                        onClick: function onClick() {
                          return handleClick(open);
                        },
                        children: [data.productsLabel, /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ChevronDownIcon */.v4q, {
                          className: classnames_default()(open ? 'text-gray-600 dark:text-white' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500 dark:group-hover:text-white dark:text-gray-300'),
                          "aria-hidden": "true"
                        })]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                      show: true,
                      as: react.Fragment,
                      enter: "transition ease-out duration-200",
                      enterFrom: "opacity-0 translate-y-1",
                      enterTo: "opacity-100 translate-y-0",
                      leave: "transition ease-in duration-150",
                      leaveFrom: "opacity-100 translate-y-0",
                      leaveTo: "opacity-0 translate-y-1",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
                        className: "absolute z-50 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-3xl",
                        "static": true,
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "rounded-lg shadow-lg ring-1 ring-black/5 overflow-hidden",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: classnames_default()('relative grid gap-6 bg-white dark:bg-gray-900 px-5 py-6 sm:gap-8 sm:p-8 md:grid-cols-2'),
                            children: data.products.map(function (item) {
                              var _item$link$target, _item$link;

                              var vertical = (0,common/* getVerticalByLink */.SP)(item.link, data.verticals, data.clusters);
                              var verticalColor = (0,colors/* getColor */.Lq)(vertical.color);
                              return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                                href: prismic_reactjs.Link.url(item.link, common/* prismicLinkResolver */.LT),
                                target: (_item$link$target = (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.target) !== null && _item$link$target !== void 0 ? _item$link$target : '_self',
                                className: classnames_default()('-m-3 p-3 flex items-stretch rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800'),
                                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                  className: classnames_default()('rounded-sm', verticalColor.bg),
                                  style: {
                                    minWidth: '4px',
                                    backgroundColor: item.color
                                  }
                                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                  className: "ml-4",
                                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                    className: "text-base font-medium text-gray-900 dark:text-gray-300",
                                    children: item.title
                                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                                    className: "mt-1 text-sm text-gray-500 dark:text-gray-300 md:hidden lg:block",
                                    children: prismic_reactjs.RichText.asText(item.description)
                                  })]
                                })]
                              }, (0,index_browser/* nanoid */.x0)());
                            })
                          }), data.seeMoreProductsLink && data.seeMoreProductsLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: "px-5 py-5 bg-gray-50 dark:bg-gray-900 sm:px-8 sm:py-8",
                            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                              href: prismic_reactjs.Link.url(data.seeMoreProductsLink, common/* prismicLinkResolver */.LT),
                              target: (_data$seeMoreProducts = (_data$seeMoreProducts2 = data.seeMoreProductsLink) === null || _data$seeMoreProducts2 === void 0 ? void 0 : _data$seeMoreProducts2.target) !== null && _data$seeMoreProducts !== void 0 ? _data$seeMoreProducts : '_self',
                              className: classnames_default()('font-medium text-primary hover:text-primary-500 dark:text-white', 'dark:hover:text-primary-400 transition ease-in-out duration-150'),
                              children: [data.seeMoreProductsLabel, ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                                "aria-hidden": "true",
                                children: "\u2192"
                              })]
                            })
                          })]
                        })
                      })
                    })]
                  })
                );
              }
            }),
            /** @deprecated use HeaderProductsMenu */
            !!((_data$businessUnit = data.businessUnit) !== null && _data$businessUnit !== void 0 && _data$businessUnit.length) && data.labelProductsByBu && /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover */.J, {
              className: "isolate z-20",
              children: function children(_ref3) {
                var open = _ref3.open;
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  onMouseEnter: function onMouseEnter() {
                    return onHover(open, MenuContext.bu, 'onMouseEnter');
                  },
                  onMouseLeave: function onMouseLeave() {
                    return onHover(open, MenuContext.bu, 'onMouseLeave');
                  },
                  onTouchStart: function onTouchStart() {
                    return onMobileTouch('onTouchStart');
                  },
                  onMouseUp: function onMouseUp() {
                    return onMobileTouch('onMouseUp');
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
                    ref: buttonBusinessUnitRef,
                    className: "inline-flex items-center gap-x-1 font-medium leading-6 text-white-1",
                    children: [data.labelProductsByBu, /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ChevronDownIcon */.v4q, {
                      className: "h-5 w-5",
                      "aria-hidden": "true"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                    show: open,
                    as: react.Fragment,
                    enter: "transition ease-out duration-200",
                    enterFrom: "opacity-0 -translate-y-1",
                    enterTo: "opacity-100 translate-y-0",
                    leave: "transition ease-in duration-150",
                    leaveFrom: "opacity-100 translate-y-0",
                    leaveTo: "opacity-0 -translate-y-1",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
                      "static": true,
                      className: "absolute inset-x-0 -z-10 bg-black-1 text-white-3 top-15",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_HeaderBU, {
                        data: data
                      })
                    })
                  })]
                });
              }
            }), !!((_data$productsMenu = data.productsMenu) !== null && _data$productsMenu !== void 0 && _data$productsMenu.length) && !!data.labelProductsMenu && /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover */.J, {
              className: "isolate z-20",
              children: function children(_ref4) {
                var open = _ref4.open;
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  onMouseEnter: function onMouseEnter() {
                    return onHover(open, MenuContext.bu, 'onMouseEnter');
                  },
                  onMouseLeave: function onMouseLeave() {
                    return onHover(open, MenuContext.bu, 'onMouseLeave');
                  },
                  onTouchStart: function onTouchStart() {
                    return onMobileTouch('onTouchStart');
                  },
                  onMouseUp: function onMouseUp() {
                    return onMobileTouch('onMouseUp');
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
                    ref: buttonBusinessUnitRef,
                    className: "inline-flex items-center gap-x-1 font-medium leading-6 text-white-1",
                    children: [data.labelProductsMenu, /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ChevronDownIcon */.v4q, {
                      className: "h-5 w-5",
                      "aria-hidden": "true"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                    show: open,
                    as: react.Fragment,
                    enter: "transition ease-out duration-200",
                    enterFrom: "opacity-0 -translate-y-1",
                    enterTo: "opacity-100 translate-y-0",
                    leave: "transition ease-in duration-150",
                    leaveFrom: "opacity-100 translate-y-0",
                    leaveTo: "opacity-0 -translate-y-1",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
                      "static": true,
                      className: "absolute inset-x-0 -z-10 bg-black-1 text-white-3 top-15",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_HeaderProductsMenu, {
                        data: data.productsMenu,
                        clusters: data.clusters
                      })
                    })
                  })]
                });
              }
            }), (_data$links = data.links) === null || _data$links === void 0 ? void 0 : _data$links.map(function (link) {
              var _link$link$target, _link$link;

              return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
                href: prismic_reactjs.Link.url(link.link, common/* prismicLinkResolver */.LT),
                target: (_link$link$target = (_link$link = link.link) === null || _link$link === void 0 ? void 0 : _link$link.target) !== null && _link$link$target !== void 0 ? _link$link$target : '_self',
                className: classnames_default()('text-base font-medium text-gray-500 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white'),
                children: link.label
              }, (0,index_browser/* nanoid */.x0)());
            }), ((_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover */.J, {
              className: "relative",
              children: function children(_ref5) {
                var open = _ref5.open;
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "pb-3 -mb-3",
                  onMouseEnter: function onMouseEnter() {
                    return onHover(open, MenuContext.content, 'onMouseEnter');
                  },
                  onMouseLeave: function onMouseLeave() {
                    return onHover(open, MenuContext.content, 'onMouseLeave');
                  },
                  onTouchStart: function onTouchStart() {
                    return onMobileTouch('onTouchStart');
                  },
                  onMouseUp: function onMouseUp() {
                    return onMobileTouch('onMouseUp');
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Button */.J.Button, {
                    ref: buttonContentRef,
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: classnames_default()(open ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-300', 'group lg:bg-white lg:dark:bg-black rounded-md inline-flex items-center text-base', 'font-medium hover:text-gray-900 dark:hover:text-white focus:outline-none', 'focus-visible:ring-2 focus-visible:ring-offset-4 focus-visible:ring-primary-500', 'cursor-default'),
                      onClick: function onClick() {
                        return handleClick(open);
                      },
                      children: [data.contentLabel, /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ChevronDownIcon */.v4q, {
                        className: classnames_default()(open ? 'text-gray-600 dark:text-white' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500 dark:group-hover:text-white dark:text-gray-300'),
                        "aria-hidden": "true"
                      })]
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                    show: open,
                    as: react.Fragment,
                    enter: "transition ease-out duration-200",
                    enterFrom: "opacity-0 translate-y-1",
                    enterTo: "opacity-100 translate-y-0",
                    leave: "transition ease-in duration-150",
                    leaveFrom: "opacity-100 translate-y-0",
                    leaveTo: "opacity-0 translate-y-1",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
                      className: "absolute z-50 -ml-4 mt-3 transform",
                      "static": true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "rounded-lg shadow-lg ring-1 ring-black/5 overflow-hidden",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: classnames_default()('relative grid gap-6 bg-white dark:bg-gray-900 p-6'),
                          children: data.content.map(function (item) {
                            var _item$link$target2, _item$link2;

                            return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
                              href: prismic_reactjs.Link.url(item.link, common/* prismicLinkResolver */.LT),
                              target: (_item$link$target2 = (_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.target) !== null && _item$link$target2 !== void 0 ? _item$link$target2 : '_self',
                              className: classnames_default()('text-base font-medium text-gray-500 hover:text-gray-900', 'dark:text-gray-300 dark:hover:text-white w-max'),
                              children: item.label
                            }, (0,index_browser/* nanoid */.x0)());
                          })
                        })
                      })
                    })
                  })]
                });
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pb-3 -mb-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CurrencyMenu/* default */.Z, {})
          })]
        }), data.loginButton && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex items-center md:ml-12",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()('ml-8 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md', 'shadow-sm text-base font-medium text-white dark:text-black bg-primary-600 hover:bg-primary-700'),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "nwWHrW",
              defaultMessage: [{
                "type": 0,
                "value": "Ingresar"
              }]
            })
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
      show: mobileOpen,
      as: react.Fragment,
      enter: "duration-200 ease-out",
      enterFrom: "opacity-0 scale-95",
      enterTo: "opacity-100 scale-100",
      leave: "duration-100 ease-in",
      leaveFrom: "opacity-100 scale-100",
      leaveTo: "opacity-0 scale-95",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
        focus: true,
        className: "absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-50",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()('rounded-lg shadow-lg ring-1 ring-black/5 bg-white', 'dark:bg-black divide-y-2 divide-gray-50 dark:divide-black dark:text-white-3'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pt-5 pb-6 px-5",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center justify-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                href: homePageLink,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "sr-only",
                  children: "Digital House"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "max-h-10 w-52",
                  children: Boolean((_data$logo2 = data.logo) === null || _data$logo2 === void 0 ? void 0 : _data$logo2.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: data.logo.url,
                    alt: data.logo.alt,
                    width: data.logo.dimensions.width,
                    height: data.logo.dimensions.height,
                    layout: "responsive",
                    objectFit: "contain"
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-mr-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(popover_esm/* Popover.Button */.J.Button, {
                  className: classnames_default()('bg-white dark:bg-black rounded-md p-2 inline-flex items-center justify-center text-gray-400', 'hover:text-gray-500 dark:text-gray-50 dark:hover:text-white hover:bg-gray-100 focus:outline-none', 'focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-500'),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "1Qb/j3",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Cerrar menú"
                      }]
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* XIcon */.b0D, {
                    className: "h-6 w-6",
                    "aria-hidden": "true",
                    onClick: handleMobileClick
                  })]
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "overflow-auto",
            style: {
              maxHeight: 'calc(100vh - 100px)'
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "pt-5 pb-6 px-5",
              children: [!!((_data$businessUnit2 = data.businessUnit) !== null && _data$businessUnit2 !== void 0 && _data$businessUnit2.length) && data.labelProductsByBu && /*#__PURE__*/(0,jsx_runtime.jsx)(components_HeaderBU, {
                data: data
              }), !!((_data$productsMenu2 = data.productsMenu) !== null && _data$productsMenu2 !== void 0 && _data$productsMenu2.length) && !!data.labelProductsMenu && /*#__PURE__*/(0,jsx_runtime.jsx)(components_HeaderProductsMenu, {
                data: data.productsMenu,
                clusters: data.clusters
              }), data.productsLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
                  className: "grid gap-6",
                  children: (_data$products2 = data.products) === null || _data$products2 === void 0 ? void 0 : _data$products2.map(function (item) {
                    var vertical = (0,common/* getVerticalByLink */.SP)(item.link, data.verticals, data.clusters);
                    var verticalColor = (0,colors/* getColor */.Lq)(vertical.color);
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                      href: prismic_reactjs.Link.url(item.link, common/* prismicLinkResolver */.LT),
                      className: "-m-3 p-3 flex items-stretch rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: classnames_default()('rounded-sm', verticalColor.bg),
                        style: {
                          minWidth: '4px',
                          backgroundColor: item.color
                        }
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "ml-4 text-base font-medium text-gray-900 dark:text-white",
                        children: item.title
                      })]
                    }, (0,index_browser/* nanoid */.x0)());
                  })
                })
              }), data.seeMoreProductsLink && data.seeMoreProductsLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
                  href: prismic_reactjs.Link.url(data.seeMoreProductsLink, common/* prismicLinkResolver */.LT),
                  className: classnames_default()('font-medium text-primary-600 hover:text-primary-500 dark:text-white dark:hover:text-primary-400', 'transition ease-in-out duration-150'),
                  children: [data.seeMoreProductsLabel, ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: "\u2192"
                  })]
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "py-6 px-5",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-4",
                children: (_data$links2 = data.links) === null || _data$links2 === void 0 ? void 0 : _data$links2.map(function (link) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
                    href: prismic_reactjs.Link.url(link.link, common/* prismicLinkResolver */.LT),
                    className: classnames_default()('text-base font-medium text-gray-900 hover:text-gray-700', 'dark:text-gray-300 dark:hover:text-white'),
                    children: link.label
                  }, (0,index_browser/* nanoid */.x0)());
                })
              }), data.loginButton && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  className: classnames_default()('w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md', 'shadow-sm text-base font-medium text-white dark:text-black bg-primary-600', 'hover:bg-primary-700'),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "nwWHrW",
                    defaultMessage: [{
                      "type": 0,
                      "value": "Ingresar"
                    }]
                  })
                })
              })]
            }), !!((_data$content2 = data.content) !== null && _data$content2 !== void 0 && _data$content2.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "py-6 px-5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-4",
                children: (_data$content3 = data.content) === null || _data$content3 === void 0 ? void 0 : _data$content3.map(function (item) {
                  var _item$link$target3, _item$link3;

                  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
                    href: prismic_reactjs.Link.url(item.link, common/* prismicLinkResolver */.LT),
                    target: (_item$link$target3 = (_item$link3 = item.link) === null || _item$link3 === void 0 ? void 0 : _item$link3.target) !== null && _item$link$target3 !== void 0 ? _item$link$target3 : '_self',
                    className: classnames_default()('text-base font-medium text-gray-500 hover:text-gray-900', 'dark:text-gray-300 dark:hover:text-white'),
                    children: item.label
                  }, (0,index_browser/* nanoid */.x0)());
                })
              })
            })]
          })]
        })
      })
    }), !!(slices !== null && slices !== void 0 && slices.length) && resolver && /*#__PURE__*/(0,jsx_runtime.jsx)(index_module/* default */.ZP, {
      resolver: resolver,
      slices: slices
    })]
  });
};

/* harmony default export */ var components_Header = (Header);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./hooks/useLocale.ts
var useLocale = __webpack_require__(4044);
// EXTERNAL MODULE: ./hooks/useTrackPayload.ts
var useTrackPayload = __webpack_require__(7445);
// EXTERNAL MODULE: ./node_modules/lodash.set/index.js
var lodash_set = __webpack_require__(1468);
var lodash_set_default = /*#__PURE__*/__webpack_require__.n(lodash_set);
// EXTERNAL MODULE: ./node_modules/lodash.clonedeep/index.js
var lodash_clonedeep = __webpack_require__(3465);
var lodash_clonedeep_default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(352);
// EXTERNAL MODULE: ./hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(689);
// EXTERNAL MODULE: ./components/FormInput.tsx
var FormInput = __webpack_require__(547);
;// CONCATENATED MODULE: ./components/Footer.tsx


function Footer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Footer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Footer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Footer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var socialIcons = [{
  name: 'Facebook',
  icon: function icon(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Footer_objectSpread(Footer_objectSpread({
      fill: "currentColor",
      viewBox: "0 0 24 24"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd" // eslint-disable-next-line max-len
        ,
        d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
        clipRule: "evenodd"
      })
    }));
  }
}, {
  name: 'Instagram',
  icon: function icon(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Footer_objectSpread(Footer_objectSpread({
      fill: "currentColor",
      viewBox: "0 0 24 24"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd" // eslint-disable-next-line max-len
        ,
        d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
        clipRule: "evenodd"
      })
    }));
  }
}, {
  name: 'Twitter',
  icon: function icon(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Footer_objectSpread(Footer_objectSpread({
      fill: "currentColor",
      viewBox: "0 0 24 24"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
      })
    }));
  }
}, {
  name: 'LinkedIn',
  icon: function icon(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Footer_objectSpread(Footer_objectSpread({
      fill: "currentColor",
      viewBox: "0 0 24 24"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd" // eslint-disable-next-line max-len
        ,
        d: "M17.833 2H6.167A4.167 4.167 0 002 6.167v11.666C2 20.134 3.866 22 6.167 22h11.666A4.167 4.167 0 0022 17.833V6.167C22 3.866 20.135 2 17.833 2zM8.667 17.833h-2.5V8.667h2.5v9.166zM7.417 7.61a1.465 1.465 0 01-1.459-1.47c0-.812.654-1.47 1.459-1.47s1.458.658 1.458 1.47c0 .812-.652 1.47-1.458 1.47zm11.25 10.223h-2.5v-4.67c0-2.806-3.334-2.594-3.334 0v4.67h-2.5V8.667h2.5v1.47c1.164-2.155 5.834-2.314 5.834 2.064v5.632z",
        clipRule: "evenodd"
      })
    }));
  }
}, {
  name: 'YouTube',
  icon: function icon(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Footer_objectSpread(Footer_objectSpread({
      fill: "currentColor",
      viewBox: "0 0 24 24"
    }, props), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd" // eslint-disable-next-line max-len
        ,
        d: "M16.23 7.102c-2.002-.136-6.462-.135-8.461 0-2.165.148-2.419 1.456-2.436 4.898.017 3.436.27 4.75 2.437 4.898 1.999.135 6.459.136 8.461 0 2.165-.148 2.42-1.457 2.437-4.898-.018-3.436-.271-4.75-2.438-4.898zm-6.23 7.12v-4.444l4.778 2.218-4.778 2.226zm2-12.222c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z",
        clipRule: "evenodd"
      })
    }));
  }
}];

var FooterItemLinks = function FooterItemLinks(_ref) {
  var title = _ref.title,
      links = _ref.links;
  var richTitle = prismic_reactjs.RichText.asText(title);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "text-sm font-semibold text-gray-400 tracking-wider uppercase inline-block",
      children: richTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: classnames_default()('mt-4 space-y-4'),
      children: links === null || links === void 0 ? void 0 : links.map(function (_ref2) {
        var _link$target;

        var label = _ref2.label,
            link = _ref2.link;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: (0,prismic/* hasLink */.A)(link) ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
            href: prismic_reactjs.Link.url(link, common/* prismicLinkResolver */.LT),
            target: (_link$target = link === null || link === void 0 ? void 0 : link.target) !== null && _link$target !== void 0 ? _link$target : '_self',
            className: "text-base text-gray-300 hover:text-white",
            children: label
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-base text-gray-300 hover:text-white hover:cursor-pointer",
            children: label
          })
        }, label);
      })
    })]
  });
};

var Footer = function Footer(_ref3) {
  var _formState$errors, _formState$errors2, _formState$errors3;

  var data = _ref3.data;
  var intl = (0,useIntl/* default */.Z)();

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var router = (0,next_router.useRouter)();
  var locale = (0,useLocale/* default */.Z)();

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      setValue = _useForm.setValue,
      formState = _useForm.formState;

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({});

  var changeLanguage = function changeLanguage(e) {
    router === null || router === void 0 ? void 0 : router.push({
      pathname: '/',
      query: ''
    }, undefined, {
      locale: e.target.value
    });
  };

  var onSubmit = (0,react.useCallback)(function (_ref4) {
    var email = _ref4.email;
    var emailNewsletter = email.toLocaleLowerCase();
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.section', 'footer');
    lodash_set_default()(payload, 'email', emailNewsletter);
    lodash_set_default()(payload, 'fields.email', emailNewsletter);
    identify({
      email: emailNewsletter
    });
    track(constants/* TrackEvents.newsletterFormSubmitted */.Um.newsletterFormSubmitted, payload, locale, true);
    setValue('email', '');
  }, [trackPayload, locale, identify, setValue, track]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    className: "bg-white dark:bg-black-1 lg:pb-14",
    "aria-labelledby": "footer-heading",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      id: "footer-heading",
      className: "sr-only",
      children: "Footer"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "xl:grid xl:grid-cols-3 xl:gap-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "grid grid-cols-1 gap-8 xl:col-span-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "md:grid md:grid-cols-3 md:gap-8",
            children: [data.col1Show ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterItemLinks, {
                title: data.col1Title,
                links: data.col1Links
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), data.col2Show ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-12 md:mt-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterItemLinks, {
                title: data.col2Title,
                links: data.col2Links
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), data.col3Show ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterItemLinks, {
                title: data.col3Title,
                links: data.col3Links
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-8 xl:mt-0",
          children: [data.showNewsletter && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-6",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "BoG/Hy",
                defaultMessage: [{
                  "type": 0,
                  "value": "Suscríbete al newsletter"
                }]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mt-4 text-sm text-gray-300",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "HMZPzp",
                defaultMessage: [{
                  "type": 0,
                  "value": "Las últimas noticias y recursos sobre habilidades digitales."
                }]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
              className: "mt-4 sm:max-w-md",
              onSubmit: handleSubmit(onSubmit),
              noValidate: true,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "sm:flex",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "email",
                  className: "sr-only",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "tkwCac",
                    defaultMessage: [{
                      "type": 0,
                      "value": "E-mail"
                    }]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput["default"], {
                  id: "email",
                  type: "email",
                  hasError: !!((_formState$errors = formState.errors) !== null && _formState$errors !== void 0 && _formState$errors.email),
                  register: register('email', {
                    required: true,
                    pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
                  }),
                  placeholder: intl.formatMessage({
                    id: "TYsexw",
                    defaultMessage: [{
                      "type": 0,
                      "value": "Ingresa tu e-mail"
                    }]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mt-3 sm:mt-0 sm:ml-3 sm:shrink-0",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    type: "submit",
                    className: "dh-button-sm",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "s2X7+W",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Suscribirme"
                      }]
                    })
                  })
                })]
              }), ((_formState$errors2 = formState.errors) === null || _formState$errors2 === void 0 ? void 0 : _formState$errors2.email) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-sm text-red-500",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "aarEp/",
                  defaultMessage: [{
                    "type": 0,
                    "value": "Uh, algo salió mal! Por favor, revisá tu email e intentá nuevamente."
                  }]
                })
              }), !((_formState$errors3 = formState.errors) !== null && _formState$errors3 !== void 0 && _formState$errors3.email) && formState.isSubmitSuccessful && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-sm text-green-600",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "690R3q",
                  defaultMessage: [{
                    "type": 0,
                    "value": "Su mail se registró con éxito!"
                  }]
                })
              })]
            })]
          }), (data === null || data === void 0 ? void 0 : data.showLangSelector) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-6 md:mt-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "pj+LYp",
                defaultMessage: [{
                  "type": 0,
                  "value": "Idioma"
                }]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
              className: "mt-4 sm:max-w-xs",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("fieldset", {
                className: "w-full",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "language",
                  className: "sr-only",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "pj+LYp",
                    defaultMessage: [{
                      "type": 0,
                      "value": "Idioma"
                    }]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
                    id: "language",
                    name: "language",
                    className: classnames_default()('appearance-none block w-full bg-none bg-white border border-gray-300 rounded-md py-2 pl-3', 'pr-10 text-base sm:text-sm text-gray-900 focus:outline-none', 'focus:ring-primary-500 focus:border-primary-500'),
                    value: locale,
                    onChange: changeLanguage,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "ar",
                      children: "Espa\xF1ol (Argentina)"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "mx",
                      children: "Espa\xF1ol (Mexico)"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "co",
                      children: "Espa\xF1ol (Colombia)"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "br",
                      children: "Portugu\xEAs (Brasil)"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "pointer-events-none absolute inset-y-0 right-0 px-2 flex items-center",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ChevronDownIcon */.v4q, {
                      className: "h-4 w-4 text-gray-400",
                      "aria-hidden": "true"
                    })
                  })]
                })]
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mt-8 border-t border-gray-700 pt-8 md:flex md:items-center md:justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex space-x-6 md:order-2",
          children: data.socialLinks.map(function (link) {
            var _link$url$target, _link$url;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkWithQuery["default"], {
              title: link.socialNetwork,
              href: prismic_reactjs.Link.url(link.url, common/* prismicLinkResolver */.LT),
              target: (_link$url$target = link === null || link === void 0 ? void 0 : (_link$url = link.url) === null || _link$url === void 0 ? void 0 : _link$url.target) !== null && _link$url$target !== void 0 ? _link$url$target : '_self',
              className: "text-gray-400 hover:text-gray-300",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: link.socialNetwork
              }), socialIcons.map(function (icon) {
                return icon.name === link.socialNetwork && /*#__PURE__*/(0,jsx_runtime.jsx)(icon.icon, {
                  className: "h-6 w-6",
                  "aria-hidden": "true"
                }, icon.name);
              })]
            }, link.socialNetwork);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mt-8 text-base text-gray-400 md:mt-0 md:order-1",
          children: "\xA9 ".concat(new Date().getFullYear(), " Digital House")
        })]
      })]
    })]
  });
};

/* harmony default export */ var components_Footer = (Footer);
;// CONCATENATED MODULE: ./utils/paths.ts
var HOME_PAGE = {
  name: 'Homepage',
  path: '/',
  regex: /^\/(?:[a-z]{2}\/)?(\?.+)?$/
};
var PRODUCTS_PAGE = {
  name: 'Products',
  path: '/products/:verticalId',
  regex: /^\/(?:[a-z]{2}\/)?(products|productos)(\?.+)?$/
};
var VERTICAL_PAGE = {
  name: 'Vertical',
  path: '/products/:verticalId',
  regex: /^\/(?:[a-z]{2}\/)?[^/]+\/[^/]+(\?.+)?$/
};
var CLUSTER_PAGE = {
  name: 'Cluster',
  path: '/products/:verticalId/:clusterId',
  regex: /^\/(?:[a-z]{2}\/)?[^/]+\/[^/]+\/[^/]+(\?.+)?$/
};
var PATHS = {
  HOME_PAGE: HOME_PAGE,
  PRODUCTS_PAGE: PRODUCTS_PAGE,
  VERTICAL_PAGE: VERTICAL_PAGE,
  CLUSTER_PAGE: CLUSTER_PAGE
};
var UNKNOWN_PATH = {
  name: undefined
};
var getPath = function getPath(currentPath) {
  var _path;

  var path;
  Object.keys(PATHS).forEach(function (key) {
    if (PATHS[key].regex.test(currentPath)) path = PATHS[key];
  });
  return (_path = path) !== null && _path !== void 0 ? _path : UNKNOWN_PATH;
};
;// CONCATENATED MODULE: ./components/Layout.tsx










var Layout = function Layout(_ref) {
  var children = _ref.children,
      header = _ref.header,
      footer = _ref.footer,
      resolver = _ref.resolver,
      product = _ref.product;
  var router = (0,next_router.useRouter)();

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      page = _useAnalytics.page;

  var _useState = (0,react.useState)(null),
      route = _useState[0],
      setRoute = _useState[1];

  (0,react.useEffect)(function () {
    if (!router.route) return;
    if (router.route) setRoute(router.route);
  }, [router.route]);
  (0,react.useEffect)(function () {
    if (!route) return;

    var _getPath = getPath(route),
        name = _getPath.name;

    page(name, product || undefined);
  }, [route]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "min-h-screen bg-white",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Header, {
      data: header,
      resolver: resolver
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Footer, {
      data: footer
    })]
  });
};

/* harmony default export */ var components_Layout = (Layout);

/***/ })

}]);